import { EntityCreateStatus } from '../../../NonReact/common/Types/SelfProvisioning/SelfProvisioningTypes'

export enum EntityCreateStatuses {
    WAITING = 'WAITING',
    CREATED = 'CREATED',
    SYNCED = 'SYNCED',
    FAILED = 'FAILED'
}

export enum CommsStatuses {
    RUNNING = 'Running',
    OUT_OF_SERVICE = 'Out-Of-Service',
    WAITING_FOR_LICENCE = 'Waiting For License',
    COMMS_INACTIVE = 'Comms Inactive',
    STARTING_COMMS = 'Starting Comms',
    STOPPING_COMMS = 'Stopping Comms',
    RUNNING_WARNINGS = 'Running (Warnings)',
    SYNCHRONISING = 'Synchronising',
    SYNCHRONISING_WARNING = 'Synchronised (Warnings)',
    SYNCHRONISED = 'Synchronised',
    SYNCHRONISATION_PENDING = 'Synchronise Pending',
    SYNCHRONISATION_FAILED = 'Synchronisation Failed',
    STOPPED = 'Stopped',
    STARTED = 'Started',
    STARTING = 'Starting',
    ENDING = 'Ending',
    JUST_STARTING_OR_CLOSING_DOWN = 'Just Starting Or Closed Down',
    UNKNOWN = 'Unknown',
    COMMS_FAILED = 'Comms Failed'
}

export const UserTypes = {
    REPORTING_SUPERVISOR: 'REPORTING_SUPERVISOR',
    ONE_USER: 'ONE_USER',
    NONE: 'NONE',

    // New billing model user types
    //
    // Extension only.
    ESSENTIALS: 'ESSENTIALS',
    PROFESSIONAL: 'PROFESSIONAL',
    ENTERPRISE: 'ENTERPRISE',

    // Agent.
    CALL_CENTRE_AGENT: 'CALL_CENTRE_AGENT',
    CALL_CENTRE_SUPERVISOR: 'CALL_CENTRE_SUPERVISOR'
}

export const FAILED_STATES: string[] = [
    CommsStatuses.COMMS_FAILED,
    CommsStatuses.SYNCHRONISATION_FAILED,
    CommsStatuses.UNKNOWN,
    CommsStatuses.STOPPING_COMMS,
    CommsStatuses.OUT_OF_SERVICE,
    CommsStatuses.ENDING
]

export const DEFAULT_STATUS: EntityCreateStatus = EntityCreateStatuses.WAITING

export enum SelfProvisioningViews {
    WELCOME,
    INITIAL_DATA_ENTRY,
    WAIT_SCREEN,
    CREATE_USERS,
    REVIEW,
    COMPLETE
}
